import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/ortho-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function Orthopaedics () {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);
  const [error, setError] = useState(null);
  const filteredDoctors = doctors.filter(doctor => doctor.department_name === "Orthopaedics, Joint Replacement and Arthroscopy");

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);

  const navigate = useNavigate();
  
  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

        {/* Navbar starts here  */}

            <Navbar />

        {/* Navbar ends here */}

        <section className="page-section">
            <div className="section-content">
                <p className='page-heading'>Orthopaedics, Joint Replacement & Arthroscopy</p>
                
                <div class="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                    <p className="page-subtitle">
                        Expert Orthopedic Care, Including Joint Replacements and 
                        <br/>
                        Cutting-Edge Arthroscopic Surgeries.
                    </p>
                </div>

                <div class="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                    <p className="page-subtitle">
                        Expert Orthopedic Care, Including Joint Replacements and Cutting-Edge Arthroscopic Surgeries.
                    </p>
                </div>
                
                <div className="page-box">
                    <div className="box-content">
                        <p>Caritas Matha Hospital's Orthopaedics, Joint Replacement & Arthroscopy department provides advanced care for joint conditions and sports injuries. Our specialists offer state-of-the-art joint replacement and arthroscopic procedures, focusing on enhancing mobility and improving quality of life through personalized treatment and innovative techniques.</p>
                    </div>
                    <div className="box-image">
                        <img src={BannerImage} alt="Orthopaedics, Joint Replacement & Arthroscopy Banner"/>
                    </div>
                </div>
            </div>
        </section>
        <section className="dept-section">
            <div
            ref={sidebarRef}
            className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
            >
            {["overview", "treatment", "facilities", "doctors"].map((section) => (
                <p
                key={section}
                className={`title ${activeSection === section ? "active" : ""}`}
                onClick={() => scrollToSection(section)}
                >
                {section.charAt(0).toUpperCase() + section.slice(1)}
                {activeSection === section && (
                    <FontAwesomeIcon
                    icon={faChevronRight}
                    className="chevron-icon"
                    />
                )}
                </p>
            ))}
            </div>
            <div ref={contentRef} className="contents">
                <div ref={sectionsRef.overview} className="overview-content">
                    <p className="content-heading">Overview</p>
                    {/* Overview content here */}
                    <p>At Caritas Matha Hospital, the Department of Orthopaedics, Joint Replacement & Arthroscopy is dedicated to providing state-of-the-art treatments for musculoskeletal conditions. We offer advanced surgical and non-surgical solutions, focusing on precision, innovation, and compassionate care. Our team of experienced orthopedic surgeons, supported by skilled medical staff, strives to enhance mobility, relieve pain, and improve the quality of life for our patients.</p>

                    <p>We prioritize patient education and involvement throughout the treatment journey, ensuring that individuals and their families are well-informed and empowered to make decisions about their care. From initial consultation to rehabilitation, our holistic approach addresses the physical, emotional, and psychological aspects of orthopedic care, fostering a supportive environment conducive to healing and recovery.</p>

                    <p>Caritas Matha Hospital is equipped with modern facilities and technology to support our comprehensive orthopedic services. Our specialized operation theaters are designed to meet the specific needs of orthopedic surgeries, enhancing surgical precision and patient safety. We continually invest in advanced diagnostic tools and therapeutic techniques to provide personalized treatment that aligns with the latest medical advancements and best practices in orthopedic care.</p>

                </div>
                <div ref={sectionsRef.treatment} className="treatment-content">
                    <p className="content-heading">Comprehensive Treatment Services</p>
                    {/* Treatment content here */}
                    
                    
                    <p>Our department offers a comprehensive range of services, including : </p>

                    <ul>
                        <li>
                          <span className="subtitle">Total Joint Replacements : </span>Expertise in knee, hip, shoulder, and elbow arthroplasty.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Arthroscopic Surgeries : </span>Procedures for knee, shoulder, and ankle joints, such as ACL and PCL reconstructions, meniscal repair, microfracture, Bankart's repair, and rotator cuff repairs.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Advanced Orthopedic Procedures : </span>Management of nonunion with bone loss, limb salvage, osteotomies for deformity correction, and more.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Sports Injuries : </span>Effective management of sports-related injuries, offering comprehensive care and innovative treatments for optimal recovery.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Pediatric Orthopaedics : </span>Specialized care for fractures and deformities in children.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Emergency Orthopedic Care : </span>Immediate treatment for fractures and trauma, provided through our Level III emergency care unit, available 24/7.</li>
                        <br/>
                    </ul>

                </div>
                <div ref={sectionsRef.facilities} className="facilities-content">
                    <p className="content-heading">Facilities</p>
                    {/* Facilities content here */}

                    <br/>
                    <ul>
                        <li>
                          <span className="subtitle">Specialized Operation Theaters : </span>Equipped with laminar flow, HEPA filters, and the latest C-arm facilities, along with imported surgical instruments adhering to international standards, facilitating advanced orthopedic procedures.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Emergency ICU : </span>A dedicated six-bed unit with a 1:1 patient-to-nurse ratio, providing intensive care for orthopedic emergencies.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Rehabilitation Services : </span>Comprehensive post-operative rehabilitation programs designed to support recovery and restore functionality.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Collaborative Care : </span>Our team collaborates closely with other departments to ensure holistic care and personalized treatment plans tailored to individual patient needs.</li>
                        <br/>
                    </ul>
                    <p>At Caritas Matha Hospital, we are committed to delivering exceptional orthopedic care, ensuring every patient receives the highest standard of treatment and support.</p>
                </div>

                <div ref={sectionsRef.doctors} className="doctors">
                    <p className="content-heading">Doctors</p>

                    {error && <p>{error}</p>}
                    {filteredDoctors.length > 0 ? (
                        <div className='doctorbox-container'>
                            {filteredDoctors.map(doctor => (
                              <div key={doctor.id} className="doctorbox">
                                <div className="doctor-box">
                                    <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                    <div className='doctor-details'>
                                        <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                        <p>{doctor['designation']}</p>
                                        <p>{ doctor.available_time }</p>
                                        <br/>
                                        {parseInt(doctor.appointment_enabled) === 1 && (
                                            <p>
                                                <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                                    Book An Appointment <FaChevronRight />
                                                </a>
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className='arrow-section'>
                                    <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                </div>
                              </div>
                            ))}
                        </div>
                    ) : (
                        !error && <p>No doctors available in this department.</p>
                    )}
                </div>
            </div>
        </section>

        {/* Footer Starts here */}

            <Footer ref={footerRef} />

        {/* Footer ends here */}
    </div>
  );
}

export default Orthopaedics;